import React, { useState, useEffect, useRef } from 'react';
import '../../css/deleteWalletSettings.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import Heading from '../../components/Heading';
import CustomBreadcrumbsSettings from '../../components/Breadcrumbs/CustomBreadcrumbsSettings';
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import CustomModalDeleteWallet from '../../components/CustomModalDeleteWallet';
import CustomModalNegBalDeleteWallet from '../../components/CustomModalNegBalDeleteWallet';
import { useSelector } from 'react-redux';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';

function DeleteWalletSettings() {

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [showModal, setShowModal] = useState(false);
    const [showNegInfoModal, setShowNegInfoModal] = useState(false);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);

    const handleSaudeEmailClick = () => {
        const emailAddress = 'geral@saude360.medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleMarketPlaceEmailClick = () => {
        const emailAddress = 'marketplace@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleActiveEmailClick = () => {
        const emailAddress = 'active@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const hadleBtnClickDeleteWallet = () => {
        setShowModal(true);
    };

    const hadleBtnClickNegInfoDeleteWallet = () => {
        setShowNegInfoModal(true);
    };

    const onHide = () => {
        setShowModal(false)
    };

    const onHideNegInfoModal = () => {
        setShowNegInfoModal(false)
    };

    const handleBtnCall = () => {
        const phoneNumber = '218458888';
        window.location.href = `tel:${phoneNumber}`;
    };


    const handleBtnGoToContacts = () => {
        const element = document.getElementById('contactMainContainerDeleteWalletSettings');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (  
        <>
        <Header/> 
        <div className={ isTablet ? "mainViewContainerDeleteWalletSettings" : ( isMobile ? 'mainViewContainerDeleteWalletSettingsTablet' : 'mainViewContainerDeleteWalletSettingsMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerDeleteWalletSettings' : ( isMobile ? 'firstTxtViewContainerDeleteWalletSettingsTablet' : 'firstTxtViewContainerDeleteWalletSettingsMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px', paddingTop: '-48px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div>
                <div className='mainHeadingViewContainerDeleteWalletSettings'> 
                    <CustomBreadcrumbsSettings hasPadding hasSettings hasDeleteWallet />
                    <Heading hasPadding hasBtnBack={false}/>
                </div>
                <div className={ isTablet ? 'secondMainContainerDeleteWalletSettings' : ( isMobile ? 'secondMainContainerDeleteWalletSettingsTablet' : 'secondMainContainerDeleteWalletSettingsMobile') }>
                    <div className={ isTablet ? 'firstSubMainContainerDeleteWalletSettings' : 'firstSubMainContainerDeleteWalletSettingsMobile' }>
                        <div className='secondTitleViewDeleteWalletSettings'>
                            <div className={ isTablet ? 'textTitleRegular400DeleteWalletSettings' : ( isMobile ? 'textTitleRegular400DeleteWalletSettingsTablet' : 'textTitleRegular400DeleteWalletSettingsMobile') }>Desligar Carteira Virtual Médis</div>
                        </div>
                        <div className='txtSecondTitleViewDeleteWalletSettings'>
                            <div className='textSecondTitleViewDeleteWalletSettings'>Esta ação apaga todo saldo e histórico de acumulação e dedução.</div>
                        </div>
                    </div>
                </div>
                
                <div className={ isTablet ? 'secondMainContainerTwoDeleteWalletSettings' : ( isMobile ? 'secondMainContainerTwoDeleteWalletSettingsTablet' : 'secondMainContainerTwoDeleteWalletSettingsMobile' ) }>
                    <div className='secondTitleMainViewContainerDeleteWalletSettings'>
                        <div className={ isTablet ? 'textTitleBoldMainViewContainerDeleteWalletSettings' : ( isMobile ? 'textTitleRegular400DeleteWalletSettingsTablet' : 'textTitleRegular400DeleteWalletSettingsMobile') }>O que saber se decidires</div>
                        <div className={ isTablet ? 'textTitleRegularMainViewContainerDeleteWalletSettings' : ( isMobile ? 'textTitleRegular400DeleteWalletSettingsTablet' : 'textTitleRegular400DeleteWalletSettingsMobile') }>apagar a carteira</div>
                    </div>
                    <div className='secondSubTitleMainViewContainerDeleteWalletSettings'>
                        <div className='textContentInfoOneMainViewContainerDeleteWalletSettings'>
                            Na Médis, valorizamos a tua liberdade e controlo sobre a tua experiência. Por isso, queremos que saibas que tens a opção de apagar a tua carteira virtual Médis a qualquer momento. No entanto, é importante teres em mente algumas consequências desta ação.
                        </div>
                        <div className='textContentInfoTwoMainViewContainerDeleteWalletSettings'>
                            Ao decidires apagar a tua carteira virtual, todos os teus dados serão eliminados, incluindo os cartões associados. Além disso, deixarás de poder acumular saldo na tua carteira e, após algum tempo, perderás acesso a qualquer saldo que tenhas deixado acumulado.
                        </div>
                        <div className='textContentInfoTwoMainViewContainerDeleteWalletSettings'>
                            É importante que tenhas consciência de que esta ação é irreversível. No entanto, se mudares de ideias no futuro, poderás sempre reativar a tua carteira a partir da página inicial da Médis.
                        </div>
                        <div className='textContentInfoTwoMainViewContainerDeleteWalletSettings'>
                            Queremos garantir que estás totalmente informado sobre as consequências da tua decisão.
                        </div>
                        <div className='textContentInfoThreeMainViewContainerDeleteWalletSettings'>
                            Se tiveres alguma dúvida ou precisares de mais informações, estamos sempre disponíveis para ajudar.
                        </div>

                        <div className={ isTablet ? 'btnDeleteViewContainerDeleteWalletSettings' : ( isMobile ? 'btnDeleteViewContainerDeleteWalletSettingsTablet' : 'btnDeleteViewContainerDeleteWalletSettingsMobile' )}>
                            <CustomButton 
                                text={'Apagar Carteira'} 
                                onPress={ isStatusCarteira === '2' ? hadleBtnClickNegInfoDeleteWallet : hadleBtnClickDeleteWallet}
                                textColor={'#00214D'}
                                borderColor={'#00214D'}
                                hasShadow={false}
                            />
                            <CustomModalDeleteWallet 
                                show={showModal} 
                                onHide={onHide} 
                            />
                            <CustomModalNegBalDeleteWallet 
                                show={showNegInfoModal} 
                                onHide={onHideNegInfoModal} 
                            />
                        </div>

                    </div>
                </div>   
            </div>
            <div id='contactMainContainerDeleteWalletSettings' className={ isTablet ? 'secondMainViewContainerDeleteWalletSettings' : ( isMobile ? 'secondMainViewContainerDeleteWalletSettingsTablet' : 'secondMainViewContainerDeleteWalletSettingsMobile' )}>
                <div className='infroMainCardViewDeleteWalletSettings'>
                    <div className='contactInfoBoxRowViewDeleteWalletSettings'>
                        <div className='emailIconSvgInfoBoxViewDeleteWalletSettings'><MdOutlineMail className='emailIconSvgInfoBoxDeleteWalletSettings' /></div>
                        <div className='txtRegularInfoBoxDeleteWalletSettings'>Email <span className='txtSemiBoldInfoBoxDeleteWalletSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='contactInfoBoxColumnViewDeleteWalletSettings'>
                        <div className='txtEmailRegularInfoBoxDeleteWalletSettings'>geral@saude360.medis.pt</div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewDeleteWalletSettings' : 'btnInfoBoxViewDeleteWalletSettingsMobile' }>
                        <CustomButton 
                            text={'Enviar email'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'email'}
                            onPress={handleSaudeEmailClick}
                        />
                    </div>
                </div>
                <div className='infroMainCardViewDeleteWalletSettings'>
                    <div className='contactInfoBoxRowViewDeleteWalletSettings'>
                        <div className='emailIconSvgInfoBoxViewDeleteWalletSettings'><MdOutlinePhoneInTalk className='emailIconSvgInfoBoxDeleteWalletSettings' /></div>
                        <div className='txtRegularInfoBoxDeleteWalletSettings'>Telefone <span className='txtSemiBoldInfoBoxDeleteWalletSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='mainSecondContactInfoBoxColumnViewDeleteWalletSettings'>
                        <div className='txtEmailSemiBoldInfoBoxDeleteWalletSettings'>210 204 887</div>
                        <div className='contactInfoBoxColumnViewDeleteWalletSettings'>
                            <div className='txtEmailRegularInfoBoxDeleteWalletSettings'>De segunda a sexta, das 9h às 18h.</div>
                            <div className='txtEmailRegularInfoBoxDeleteWalletSettings'>Custo de chamada para rede fixa nacional.</div>
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewDeleteWalletSettings' : 'btnInfoBoxViewDeleteWalletSettingsMobile' }>
                        <CustomButton 
                            text={'Ligar'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'phone'}
                            onPress={handleBtnCall}
                        />
                    </div>
                </div>
            </div>
        </div>
        <Footer/> 
        </>
    )
}

export default DeleteWalletSettings;